export default __webpack_public_path__ + "img/bg-login-page-dark.e6429241.svg";